import { parsePhoneNumberFromString } from "libphonenumber-js";
export function phoneNumberRule() {
    return function (input) {
        var _a;
        return ((_a = parsePhoneNumberFromString(input, "JP")) === null || _a === void 0 ? void 0 : _a.isValid()) === true ||
            "有効な電話番号を入力してください";
    };
}
//# sourceMappingURL=phone-number.js.map